import { PlaylistEntry, AddVideoAction, RemoveVideoAction, RemoveAllAction } from './types'

import { ActionCreator } from 'redux';

export const addVideo: ActionCreator<AddVideoAction> = (entry: PlaylistEntry) => ({
    type: '@@playlist/ADD_VIDEO',
    payload: {
      entry
    }
})

export const removeVideo: ActionCreator<RemoveVideoAction> = (name: string) => ({
    type: '@@playlist/REMOVE_VIDEO',
    payload: {
        name
    }
})

export const removeAll: ActionCreator<RemoveAllAction> = () => ({
    type: '@@playlist/REMOVE_ALL'
})
